import React, { createContext, useContext } from 'react';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { translations } from './translations';

// Zustand store for language preference
export const useLanguageStore = create(
  persist(
    (set) => ({
      language: 'fr',
      setLanguage: (lang) => set({ language: lang }),
    }),
    {
      name: 'hst-language',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

// React Context for convenience
const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const language = useLanguageStore((s) => s.language);
  const t = (key, vars) => {
    const raw = translations[language]?.[key] || translations.fr[key] || key;
    if (!vars) return raw;
    return raw.replace(/\{\{(\w+)\}\}/g, (_, name) => (vars[name] !== undefined ? vars[name] : `{{${name}}}`));
  };

  return (
    <I18nContext.Provider value={{ t, language }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useTranslation = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    // Fallback if outside provider
    return {
      t: (key, vars) => {
        const raw = translations.fr[key] || key;
        if (!vars) return raw;
        return raw.replace(/\{\{(\w+)\}\}/g, (_, name) => (vars[name] !== undefined ? vars[name] : `{{${name}}}`));
      },
      language: 'fr',
    };
  }
  return ctx;
};

/**
 * Standalone t() for non-React code (Zustand slices, pure helpers).
 * Reads the current language from `useLanguageStore` snapshot.
 * 02/06/2026 — Added to support i18n in notification bodies / message
 * builders (severance, etc.) without requiring a React context.
 */
export const tStandalone = (key, vars) => {
  const language = useLanguageStore.getState().language;
  const raw = translations[language]?.[key] || translations.fr[key] || key;
  if (!vars) return raw;
  return raw.replace(/\{\{(\w+)\}\}/g, (_, name) => (vars[name] !== undefined ? vars[name] : `{{${name}}}`));
};
